import React, { useState } from "react";
import useBingoStore from "../store";
import { FaRandom, FaRedoAlt, FaRedo, FaCog, FaStop } from "react-icons/fa";
import PopOver from "../components/PopOver";
import PopOver3D from "../components/PopOver3D";
import BingoTable from "../components/BingoTable";
import ConfigurarBingo from "../components/ConfigurarBingo";
import SettingsModal from "../components/SettingsModal";

const BingoPage = () => {
  const { 
    drawnNumbers, 
    drawNumber, 
    saveNumber, 
    resetGame, 
    drawnNumber, 
    isConfigured, 
    animationOption,
    soundOption,
    finalizeBingo 
  } = useBingoStore();
  
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [reshow, setReshow] = useState(false);
  const [textSize, setTextSize] = useState(3);
  const [settingsOpen, setSettingsOpen] = useState(false);

  // If not configured, show the configuration screen
  if (!isConfigured) {
    return <ConfigurarBingo />;
  }

  const handlePopoverClose = () => {
    saveNumber();
    setPopoverOpen(false);
  };

  const handleDrawNumber = () => {
    drawNumber();
    setReshow(false);
    setPopoverOpen(true);
  };

  const handleResetGame = () => {
    const confirmed = window.confirm("Tem certeza que deseja reiniciar o jogo? Os números sorteados serão zerados.");
    if (confirmed) {
      resetGame();
    }
  };

  const handleFinalizeBingo = () => {
    const confirmed = window.confirm(
      "Tem certeza que deseja finalizar este bingo? Você voltará para a tela de configuração e todo o progresso será perdido."
    );
    if (confirmed) {
      finalizeBingo();
    }
  };

  const handleTextSizeChange = (size) => {
    setTextSize(size);
  };

  const handleReDisplayLastNumber = () => {
    if (drawnNumber !== null) {
      setReshow(true);
      setPopoverOpen(true);
    }
  };

  const use3DAnimation = animationOption === "3d";

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="w-full max-w-5xl flex flex-wrap items-center justify-between mb-2 gap-2">
        <h1 className="text-4xl font-bold">Bingo</h1>
        <div className="flex flex-wrap gap-2 items-end">
          <button 
            onClick={handleDrawNumber} 
            className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-lg hover:from-blue-600 hover:to-blue-700 shadow-md transition-all flex items-center gap-2"
          >
            <FaRandom />
            Sortear Número
          </button>
          <button
            onClick={handleReDisplayLastNumber}
            className="bg-gradient-to-r from-yellow-500 to-amber-500 text-white px-4 py-2 rounded-lg hover:from-yellow-600 hover:to-amber-600 shadow-md transition-all flex items-center gap-2"
          >
            <FaRedo />
            Re-exibir
          </button>
          <button 
            onClick={handleResetGame} 
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-4 py-2 rounded-lg hover:from-orange-600 hover:to-orange-700 shadow-md transition-all flex items-center gap-2"
          >
            <FaRedoAlt />
            Reiniciar
          </button>
          <button
            onClick={() => setSettingsOpen(true)}
            className="bg-gradient-to-r from-gray-500 to-gray-600 text-white px-4 py-2 rounded-lg hover:from-gray-600 hover:to-gray-700 shadow-md transition-all flex items-center gap-2"
          >
            <FaCog />
            Configurações
          </button>
          <button
            onClick={handleFinalizeBingo}
            className="bg-gradient-to-r from-red-500 to-red-600 text-white px-4 py-2 rounded-lg hover:from-red-600 hover:to-red-700 shadow-md transition-all flex items-center gap-2"
          >
            <FaStop />
            Finalizar Bingo
          </button>
          <div className="flex gap-1 items-end ml-2">
            {[1, 2, 3, 4, 5].map((size) => (
              <button
                key={size}
                onClick={() => handleTextSizeChange(size)}
                className={`px-2 py-1 rounded transition-all ${
                  textSize === size 
                    ? "bg-blue-500 text-white shadow-md" 
                    : "bg-gray-200 hover:bg-gray-300"
                }`}
                title={`Tamanho ${size}`}
              >
                {size}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mb-4">
        {!popoverOpen && drawnNumber !== null && (
          <p className="text-lg font-semibold bg-green-100 text-green-800 px-4 py-2 rounded-lg">
            Último número sorteado: <span className="text-2xl">{drawnNumber}</span>
          </p>
        )}
      </div>

      {popoverOpen && drawnNumber !== null && (
        use3DAnimation ? (
          <PopOver3D number={drawnNumber} onClose={handlePopoverClose} reshow={reshow} soundOption={soundOption} />
        ) : (
          <PopOver number={drawnNumber} onClose={handlePopoverClose} reshow={reshow} soundOption={soundOption} />
        )
      )}

      <BingoTable drawnNumbers={drawnNumbers} size={textSize} />

      <SettingsModal isOpen={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </div>
  );
};

export default BingoPage;
